import { Linkedin, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BrandLogo from './BrandLogo';
interface FooterProps {
  // 'scene' renders the colophon used by the public marketing pages.
  variant?: 'default' | 'scene';
}

export default function Footer({ variant = 'default' }: FooterProps) {
  const {
    t
  } = useTranslation();
  const currentYear = new Date().getFullYear();
  if (variant === 'scene') {
    return <footer className="colophon">
      <div className="wrap" data-rv="up">
        <div className="colophon__grid">
          <div className="grid gap-6 content-start">
            <BrandLogo showTagline size="lg" className="h-14" />
            <p className="lede max-w-[22ch]">{t('footer.statement')}</p>
          </div>
          <div className="grid gap-4 content-start">
            <p className="mono">{t('footer.index')}</p>
            <ul className="grid gap-2 text-[15px]">
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/pricing">{t('nav.pricing')}</Link></li>
              <li><Link to="/how-it-works">{t('nav.how_it_works')}</Link></li>
              <li><Link to="/about">{t('nav.about', 'About')}</Link></li>
              <li><Link to="/support">{t('nav.support')}</Link></li>
            </ul>
          </div>
          <div className="grid gap-4 content-start">
            <p className="mono">{t('footer.contact')}</p>
            <ul className="grid gap-2 text-[15px]">
              <li><a href="mailto:contact@targetna.com">contact@targetna.com</a></li>
              <li><a href="tel:+201228351416" dir="ltr">+20 122 835 1416</a></li>
              <li>
                <a href="https://www.linkedin.com/company/targetna/about/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-wrap justify-between gap-x-8 gap-y-2 border-t border-[var(--hairline)] py-6 text-[13px] text-[var(--graphite)]">
          <span>© {currentYear} Targetna AI. {t('footer.rights')}</span>
          <span dir="auto">{t('footer.built_by')}</span>
        </div>
      </div>
    </footer>;
  }
  return <footer className="border-t border-border/70 bg-secondary/70 mt-auto">
    <div className="container mx-auto px-4 py-12">
      <div className="grid md:grid-cols-4 gap-8">
        {/* Brand */}
        <div className="space-y-4">
          <BrandLogo showTagline size="sm" />
          <p className="text-sm text-muted-foreground max-w-xs">
            Automate your real estate sales with AI-powered campaigns.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-semibold mb-4 text-accent">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/" className="text-sm text-muted-foreground hover:text-accent">
                {t('nav.home')}
              </Link>
            </li>
            <li>
              <Link to="/pricing" className="text-sm text-muted-foreground hover:text-accent">
                {t('nav.pricing')}
              </Link>
            </li>
            <li>
              <Link to="/how-it-works" className="text-sm text-muted-foreground hover:text-accent">
                {t('nav.how_it_works')}
              </Link>
            </li>
            <li>
              <Link to="/support" className="text-sm text-muted-foreground hover:text-accent">
                {t('nav.support')}
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-semibold mb-4 text-accent">Contact</h3>
          <ul className="space-y-2">
            <li className="flex items-center gap-2 text-sm text-muted-foreground">
              <Mail className="h-4 w-4 text-accent" />
              <span>contact@targetna.com</span>
            </li>
            <li className="flex items-center gap-2 text-sm text-muted-foreground">
              <Phone className="h-4 w-4 text-accent" />
              <span>+20 122 835 1416</span>
            </li>
            <li className="flex items-center gap-2 text-sm text-muted-foreground">
              <Linkedin className="h-4 w-4 text-accent" />
              <a href="https://www.linkedin.com/company/targetna/about/"
                 target="_blank"
                 rel="noopener noreferrer"
                 className="hover:text-accent">
                Targetna
              </a>
            </li>
          </ul>
        </div>

        {/* Deployment */}

      </div>

      <div className="border-t border-border/70 mt-8 pt-8 text-center text-sm text-muted-foreground">
        © {currentYear} Targetna AI. All rights reserved.
        <p className="mt-1" dir="auto">This product is built and developed by مؤسسه الياسمين - بي اي سي سي</p>
      </div>
    </div>
  </footer>;
}